import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Col,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";

function BxvatList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  // Căutare + paginare sincronizate cu backend-ul
  const fetchItems = useCallback(async () => {
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/bxvat/", {
        params: {
          search,
          skip,
          limit: itemsPerPage,
        },
      });
      setItems(res.data.items);
      setTotalCount(res.data.total);
      // console.log("🧾 Răspuns complet:", res);
      // console.log("📦 Date din res.data:", res.data);
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0); // reset pagină când cauți
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")
    ) {
      try {
        await api.delete(`/bxvat/${id}`);
        fetchItems(); // reîncărcăm lista după ștergere
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  return (
    <Container className="mt-4">
      <h2>Lista Bxvat</h2>
      <Col className="text-end">
        <Button className="mb-3" onClick={() => navigate("/bxvat/create")}>
          Adaugă
        </Button>
      </Col>
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Caută după denumire"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button variant="outline-danger" onClick={() => setSearchParams({})}>
            Curăță
          </Button>
        )}
      </InputGroup>

      <div className="mb-3">
        <label>
          Rânduri pe pagină:&nbsp;
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>cod</th>
            <th>descriere</th>
            <th>procent</th>
            <th>ordine</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              <td>{it.id}</td>
              <td>{it.cod}</td>
              <td>{it.descriere}</td>
              <td>{it.procent}</td>
              <td>{it.ordine}</td>
              <td>
                <Button size="sm" onClick={() => navigate(`/bxvat/${it.id}`)}>
                  Editează
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(it.id)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        forcePage={currentPage}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default BxvatList;
